export const SET_BRANDING_THEME = "SET_BRANDING_THEME";
export const SET_SHARES_LOGO_STORED_FILE_UUID  = "SET_SHARES_LOGO_STORED_FILE_UUID";

export function setBrandingTheme(value) {
  return {
    type: SET_BRANDING_THEME,
    value,
  }
}

export function setSharesLogoStoredFileUUID(value) {
  return {
    type: SET_SHARES_LOGO_STORED_FILE_UUID,
    value,
  }
}

